import React from "react";
import {
  GeneralFillOutSurvey,
  Background,
  ContentQuestions,
  GeneralStyle,
  LowerWrapper,
  StyledButton,
  RadioSurvey,
  RadioSurveyLike,
  ContainerIterationQuestionlike,
  ContainerIterationYesOrNot,
  SizeFace,
  OptionsSection,
  OptionWrapper,
  SizeImgRating,
  Ismandatory,
  ContentMandatory,
  ValidationTextStyle,
  ContentInternal,
  ShowImageContainer,
  OptionWrapperOther,
  SmileyFace,
  DropdownOptionWrapper,
  SelectsSection,
} from "./FormFilling.styled";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import FavoriteRoundedIcon from "@material-ui/icons/FavoriteRounded";
import ThumbUpAltOutlinedIcon from "@material-ui/icons/ThumbUpAltOutlined";
import ThumbDownAltOutlinedIcon from "@material-ui/icons/ThumbDownAltOutlined";
//FACE 5
import SentimentVerySatisfiedTwoToneIcon from "@material-ui/icons/SentimentVerySatisfiedTwoTone";
//FACE 4
import EmojiEmotionsTwoToneIcon from "@material-ui/icons/EmojiEmotionsTwoTone";
//FACE 3
import SentimentSatisfiedTwoToneIcon from "@material-ui/icons/SentimentSatisfiedTwoTone";
//FACE 2
import MoodBadTwoToneIcon from "@material-ui/icons/MoodBadTwoTone";
//FACE 1
import SentimentVeryDissatisfiedTwoToneIcon from "@material-ui/icons/SentimentVeryDissatisfiedTwoTone";
import { Form } from "react-bootstrap";
import { SlideDown } from "react-slidedown";
import "react-slidedown/lib/slidedown.css";
import HighAlertQuestionBlock from "../../HighAlertQuestionBlock";
import { toBase64 } from "../../../helpers/toBase64";

const ImageComponent = ({
  elementKey,
  colorPicker,
  idQuestion,
  setQualification,
  selectImage,
  internalCode,
  typeQuestion,
}) => {
  switch (selectImage) {
    case "star":
      return (
        <StarRoundedIcon
          key={elementKey}
          className="icon-selected-Survey-answer ImageRating"
          onClick={() =>
            setQualification({
              elementKey,
              selectImage,
              idQuestion,
              internalCode,
              typeQuestion,
            })
          }
          style={{ fill: colorPicker }}
        ></StarRoundedIcon>
      );
    case "heart":
      return (
        <FavoriteRoundedIcon
          key={elementKey}
          className="icon-selected-preview ImageRating"
          onClick={() =>
            setQualification({
              elementKey,
              selectImage,
              idQuestion,
              internalCode,
              typeQuestion,
            })
          }
          style={{ fill: colorPicker }}
        ></FavoriteRoundedIcon>
      );
    default:
      return (
        <Form.Check
          inline
          label={elementKey}
          type="radio"
          id={`number-${elementKey}`}
          name={`number-${idQuestion}`}
          onClick={() =>
            setQualification({
              elementKey,
              selectImage,
              idQuestion,
              internalCode,
              typeQuestion,
            })
          }
        />
      );
  }
};

const RadioButtonComponent = ({
  elementKey,
  elementValue,
  setAnswerQuestion,
  idQuestion,
  internalCode,
  typeQuestion,
  configuration,
  answerConfiguration,
  question,
  answersDependent,
  setanswersDependent,
  surveyquestiondata,
  QuestionsSave,
  setQuestionsSave,
}) => {
  return (
    <RadioSurvey>
      <input
        type="radio"
        id={`radioButton-${elementKey}`}
        name={`radioButton-${idQuestion}`}
        defaultValue={elementValue}
        onChange={() => {
          let position = answersDependent.findIndex(
            (f) => f.idQuestionSurvey === question.idQuestionSurvey
          );
          if (position > -1) {
            surveyquestiondata
              .filter(
                (f) =>
                  f.dependentAnswer === answersDependent[position].answer &&
                  f.idParentQuestion ===
                    answersDependent[position].idQuestionSurvey
              )
              .forEach((m) => {
                let positionDelete = QuestionsSave.findIndex(
                  (i) => i.idQuestion === m.idQuestion
                );
                if (positionDelete > -1)
                  QuestionsSave.splice(positionDelete, 1);
              });
            setQuestionsSave(QuestionsSave);
            answersDependent[position].answer = elementValue;
          } else
            answersDependent.push({
              idQuestionSurvey: question.idQuestionSurvey,
              answer: elementValue,
            });
          //setanswersDependent(answersDependent)

          setAnswerQuestion(
            elementValue,
            idQuestion,
            internalCode,
            typeQuestion
          );
        }}
      />
      <label
        style={
          configuration.customStyle ? configuration.answer : answerConfiguration
        }
        id="labelRadioSurvey"
      >
        {elementValue}
      </label>
    </RadioSurvey>
  );
};
const RadioButtonlikeComponent = ({
  elementKey,
  elementValue,
  setAnswerQuestionLike,
  idQuestion,
  internalCode,
  typeQuestion,
  configuration,
  answerConfiguration,
}) => {
  return (
    <RadioSurveyLike>
      <input
        type="radio"
        id={`radioButtonLike-${elementKey}`}
        name={`radioButtonLike-${idQuestion}`}
        defaultValue={elementValue ? elementValue : null}
        onChange={() =>
          setAnswerQuestionLike(
            elementValue,
            idQuestion,
            internalCode,
            typeQuestion
          )
        }
      />
      {elementValue === "thumbUp" ? (
        <ThumbUpAltOutlinedIcon
          style={
            configuration.customStyle
              ? configuration.answer
              : answerConfiguration
          }
        />
      ) : (
        <ThumbDownAltOutlinedIcon
          style={
            configuration.customStyle
              ? configuration.answer
              : answerConfiguration
          }
        />
      )}
    </RadioSurveyLike>
  );
};

const FormFilling = ({
  formData,
  questiondata,
  saveForm,
  buttonSaveConfiguration,
  backgroundConfiguration,
  questionsConfiguration,
  answerConfiguration,
  mandatoryMissing,
  imgBackground,
  banners,
  logoSurvey,
  logoConfiguration,
  QuestionsSave,
  setQuestionsSave,
  imagesChoice,
  buttonSaveConfigurationPreview = true,
  answersDependent = [],
  setanswersDependent,
  setHighPriority,
  setHighPriorityReason,
  showError,
}) => {
  const title = formData?.label;
  const initalColor = "white";
  const showMandatory = (question, config) => {
    const exists = mandatoryMissing.findIndex(
      (M) => M === question.idQuestionForm
    );

    return (
      exists !== -1 &&
      question.isMandatory &&
      config.validationText && (
        <ValidationTextStyle>{config?.validationText}</ValidationTextStyle>
      )
    );
  };

  const orderArraySaveData = (data) => {
    let position =
      QuestionsSave &&
      QuestionsSave.findIndex((x) => x.idQuestion === data.idQuestion);

    if (position !== -1) {
      let dataSave = [];
      Object.assign(dataSave, QuestionsSave);
      dataSave[position] = data;
      setQuestionsSave(dataSave);
    } else {
      setQuestionsSave([...QuestionsSave, data]);
    }
  };

  const setQualification = ({
    elementKey,
    selectImage,
    idQuestion,
    internalCode,
    typeQuestion,
  }) => {
    orderArraySaveData({
      idAnswerClient: 0,
      code: null,
      idQuestion: idQuestion,
      idSurvey: formData.idForm,
      titleAnswer: selectImage,
      answerClient: elementKey,
      active: true,
      createUser: "",
      internalCode: internalCode.length > 0 ? internalCode[0].internalCode : "",
      typeQuestion: typeQuestion,
    });
  };
  const setQualificationSmile = (
    value,
    lbtext,
    idQuestion,
    internalCode,
    typeQuestion
  ) => {
    orderArraySaveData({
      idAnswerClient: 0,
      code: null,
      idQuestion: idQuestion,
      idSurvey: formData.idForm,
      titleAnswer: lbtext,
      answerClient: value,
      active: true,
      createUser: "",
      internalCode: internalCode.length > 0 ? internalCode[0].internalCode : "",
      typeQuestion: typeQuestion,
    });
  };
  const setQualificationOpenText = (
    e,
    idQuestion,
    internalCode,
    typeQuestion
  ) => {
    e.preventDefault();
    orderArraySaveData({
      idAnswerClient: 0,
      code: null,
      idQuestion: idQuestion,
      idSurvey: formData.idForm,
      titleAnswer: null,
      answerClient: e.target.value,
      active: true,
      createUser: "",
      internalCode: internalCode.length > 0 ? internalCode[0].internalCode : "",
      typeQuestion: typeQuestion,
    });
  };

  const setQualificationAttachFile = async (
    e,
    idQuestion,
    internalCode,
    typeQuestion
  ) => {
    let file = e.target?.files[0];
    let base64Content = await toBase64(file);
    base64Content = base64Content.split("base64,")[1];
    orderArraySaveData({
      idAnswerClient: 0,
      code: null,
      idQuestion: idQuestion,
      idSurvey: formData.idForm,
      titleAnswer: null,
      answerClient: file?.name,
      active: true,
      createUser: "",
      internalCode: internalCode.length > 0 ? internalCode[0].internalCode : "",
      typeQuestion: typeQuestion,
      base64FileContent: base64Content,
    });
  };
  const setQualificationDropdownSingleSelect = (
    e,
    idQuestion,
    internalCode,
    typeQuestion
  ) => {
    orderArraySaveData({
      idAnswerClient: 0,
      code: null,
      idQuestion: idQuestion,
      idSurvey: formData.idForm,
      titleAnswer: null,
      answerClient: e.target.value,
      active: true,
      createUser: "",
      internalCode: internalCode.length > 0 ? internalCode[0].internalCode : "",
      typeQuestion: typeQuestion,
    });
  };
  const setQualificationYesNoAndLike = (
    elementValue,
    idQuestion,
    internalCode,
    typeQuestion
  ) => {
    orderArraySaveData({
      idAnswerClient: 0,
      code: null,
      idQuestion: idQuestion,
      idSurvey: formData.idForm,
      titleAnswer: null,
      answerClient: elementValue,
      active: true,
      createUser: "",
      internalCode: internalCode.length > 0 ? internalCode[0].internalCode : "",
      typeQuestion: typeQuestion,
    });
  };
  const setQualificationMultipleChoice = (
    nameL1_BRAN,
    idQuestion,
    internalCode,
    typeQuestion
  ) => {
    let positionQuestionsSave = QuestionsSave.findIndex(
      (x) => x.idQuestion === idQuestion
    );
    let choiceSelected = nameL1_BRAN;

    if (positionQuestionsSave !== -1) {
      choiceSelected = QuestionsSave[positionQuestionsSave].answerClient;
      let choiceSelectedArray = choiceSelected.split("|");
      let position = choiceSelectedArray.findIndex((x) => x === nameL1_BRAN);
      if (position === -1) {
        choiceSelectedArray.push(nameL1_BRAN);
      } else {
        choiceSelectedArray.splice(position, 1);
      }
      choiceSelected = choiceSelectedArray.join("|");
    }
    orderArraySaveData({
      idAnswerClient: 0,
      code: null,
      idQuestion: idQuestion,
      idSurvey: formData.idForm,
      titleAnswer: null,
      answerClient: choiceSelected.charAt(0).includes("|")
        ? choiceSelected.substr(1)
        : choiceSelected,
      active: true,
      createUser: "",
      internalCode: internalCode.length > 0 ? internalCode[0].internalCode : "",
      typeQuestion: typeQuestion,
    });
  };
  const setQualificationMultipleChoiceSingle = (
    child,
    idQuestion,
    internalCode,
    typeQuestion,
    questionProps
  ) => {
    let position = answersDependent.findIndex(
      (f) => f.idQuestionSurvey === questionProps.idQuestionSurvey
    );
    if (position > -1) {
      questiondata
        .filter(
          (f) =>
            f.dependentAnswer === answersDependent[position].answer &&
            f.idParentQuestion === answersDependent[position].idQuestionSurvey
        )
        .forEach((m) => {
          let positionDelete = QuestionsSave.findIndex(
            (i) => i.idQuestion === m.idQuestion
          );
          if (positionDelete > -1) QuestionsSave.splice(positionDelete, 1);
        });
      setQuestionsSave(QuestionsSave);
      answersDependent[position].answer =
        typeQuestion === "MultipleChoiceImageSingleSelect"
          ? child.replace("|", "-")
          : child;
    } else
      answersDependent.push({
        idQuestionSurvey: questionProps.idQuestionSurvey,
        answer:
          typeQuestion === "MultipleChoiceImageSingleSelect"
            ? child.replace("|", "-")
            : child,
      });
    //setanswersDependent(answersDependent)
    orderArraySaveData({
      idAnswerClient: 0,
      code: null,
      idQuestion: idQuestion,
      idSurvey: formData.idForm,
      titleAnswer: null,
      answerClient: child,
      active: true,
      createUser: "",
      internalCode: internalCode.length > 0 ? internalCode[0].internalCode : "",
      typeQuestion: typeQuestion,
    });
  };

  const answersType = (
    jsonConfiguration,
    idQuestion,
    tpsurveyAnswerQuestionSurveys,
    questionProps
  ) => {
    let configuration = {};
    if (jsonConfiguration) {
      configuration = JSON.parse(jsonConfiguration);
    }
    switch (questionProps.questionType) {
      case "OpenText":
        return (
          <textarea
            onBlur={(e) =>
              setQualificationOpenText(
                e,
                idQuestion,
                tpsurveyAnswerQuestionSurveys,
                questionProps.questionType
              )
            }
          ></textarea>
        );
      case "ImageRating":
        let dataStars = [];
        let colorImageRating = "";
        let actualQuestion = QuestionsSave.filter((x) => {
          return x.idQuestion === idQuestion;
        });
        for (let i = 1; i <= JSON.parse(configuration.cantElements); i++) {
          colorImageRating = configuration.colorPicker;
          let f = {
            key: i,
            elementKey: i,
            colorPicker:
              actualQuestion.length && actualQuestion[0].answerClient >= i
                ? configuration.colorPicker
                : initalColor,
            setQualification: setQualification,
            selectImage: configuration.nameShape,
          };
          dataStars.push(f);
        }
        let arrayImageRating = [];

        dataStars.length > 0 &&
          dataStars.forEach((data) => {
            arrayImageRating = [
              ...arrayImageRating,
              <ImageComponent
                key={data.key}
                elementKey={data.elementKey}
                idQuestion={idQuestion}
                colorPicker={data.colorPicker}
                setQualification={data.setQualification}
                selectImage={data.selectImage}
                internalCode={tpsurveyAnswerQuestionSurveys}
                typeQuestion={configuration.typeQuestion}
              />,
            ];
          });
        return (
          <SizeImgRating
            backgroundColor={configuration?.background}
            color={colorImageRating}
          >
            {arrayImageRating.reverse()}
          </SizeImgRating>
        );
      case "QuestionYesNo":
        let dataYesOrNot = [];
        configuration.questionSettings.forEach((qYoN) => {
          dataYesOrNot = [
            ...dataYesOrNot,
            <RadioButtonComponent
              key={qYoN.id}
              elementKey={qYoN.id}
              elementValue={qYoN.value}
              setAnswerQuestion={setQualificationYesNoAndLike}
              idQuestion={idQuestion}
              internalCode={tpsurveyAnswerQuestionSurveys}
              typeQuestion={configuration.typeQuestion}
              configuration={configuration}
              answerConfiguration={answerConfiguration}
              question={questionProps}
              answersDependent={answersDependent}
              setanswersDependent={setanswersDependent}
              surveyquestiondata={questiondata}
              QuestionsSave={QuestionsSave}
              setQuestionsSave={setQuestionsSave}
            />,
          ];
        });
        return (
          <ContainerIterationYesOrNot>
            {dataYesOrNot}
          </ContainerIterationYesOrNot>
        );
      case "QuestionLike":
        let dataLike = [];
        configuration.questionSettings.forEach((ql) => {
          dataLike = [
            ...dataLike,
            <RadioButtonlikeComponent
              key={ql.id}
              elementKey={ql.id}
              elementValue={ql.value}
              setAnswerQuestionLike={setQualificationYesNoAndLike}
              idQuestion={idQuestion}
              internalCode={tpsurveyAnswerQuestionSurveys}
              typeQuestion={configuration.typeQuestion}
              configuration={configuration}
              answerConfiguration={answerConfiguration}
            />,
          ];
        });
        return (
          <ContainerIterationQuestionlike
            backgroundColor={configuration?.background}
          >
            {dataLike}
          </ContainerIterationQuestionlike>
        );
      case "SmileyFaces":
        let dataSmile = [];
        let actualQuestionSmile = QuestionsSave.filter((x) => {
          return x.idQuestion === idQuestion;
        });
        configuration.caritas
          .sort((x, y) => {
            return parseInt(y.value) - parseInt(x.value);
          })
          .forEach((f, index) => {
            switch (parseInt(f.face)) {
              case 5:
                dataSmile = [
                  <SizeFace key={idQuestion + "_" + index} color={f.color}>
                    <h3
                      style={
                        configuration.customStyle
                          ? configuration.answer
                          : answerConfiguration
                      }
                    >
                      {" "}
                      {f.lbtext}{" "}
                    </h3>
                    <SentimentVeryDissatisfiedTwoToneIcon
                      onClick={() =>
                        setQualificationSmile(
                          f.value,
                          f.lbtext,
                          idQuestion,
                          tpsurveyAnswerQuestionSurveys,
                          configuration.typeQuestion
                        )
                      }
                      style={{
                        fill:
                          actualQuestionSmile.length &&
                          actualQuestionSmile[0].answerClient === f.value
                            ? f.color
                            : f.color + "5e",
                      }}
                    />
                  </SizeFace>,
                  ...dataSmile,
                ];
                break;
              case 4:
                dataSmile = [
                  <SizeFace key={idQuestion + "_" + index} color={f.color}>
                    <h3
                      style={
                        configuration.customStyle
                          ? configuration.answer
                          : answerConfiguration
                      }
                    >
                      {" "}
                      {f.lbtext}{" "}
                    </h3>
                    <MoodBadTwoToneIcon
                      onClick={() =>
                        setQualificationSmile(
                          f.value,
                          f.lbtext,
                          idQuestion,
                          tpsurveyAnswerQuestionSurveys,
                          configuration.typeQuestion
                        )
                      }
                      style={{
                        fill:
                          actualQuestionSmile.length &&
                          actualQuestionSmile[0].answerClient === f.value
                            ? f.color
                            : f.color + "5e",
                      }}
                    />
                  </SizeFace>,
                  ...dataSmile,
                ];
                break;
              case 3:
                dataSmile = [
                  <SizeFace key={idQuestion + "_" + index} color={f.color}>
                    <h3
                      style={
                        configuration.customStyle
                          ? configuration.answer
                          : answerConfiguration
                      }
                    >
                      {" "}
                      {f.lbtext}{" "}
                    </h3>
                    <SentimentSatisfiedTwoToneIcon
                      onClick={() =>
                        setQualificationSmile(
                          f.value,
                          f.lbtext,
                          idQuestion,
                          tpsurveyAnswerQuestionSurveys,
                          configuration.typeQuestion
                        )
                      }
                      style={{
                        fill:
                          actualQuestionSmile.length &&
                          actualQuestionSmile[0].answerClient === f.value
                            ? f.color
                            : f.color + "5e",
                      }}
                    />
                  </SizeFace>,
                  ...dataSmile,
                ];
                break;
              case 2:
                dataSmile = [
                  <SizeFace key={idQuestion + "_" + index} color={f.color}>
                    <h3
                      style={
                        configuration.customStyle
                          ? configuration.answer
                          : answerConfiguration
                      }
                    >
                      {" "}
                      {f.lbtext}{" "}
                    </h3>
                    <EmojiEmotionsTwoToneIcon
                      onClick={() =>
                        setQualificationSmile(
                          f.value,
                          f.lbtext,
                          idQuestion,
                          tpsurveyAnswerQuestionSurveys,
                          configuration.typeQuestion
                        )
                      }
                      style={{
                        fill:
                          actualQuestionSmile.length &&
                          actualQuestionSmile[0].answerClient === f.value
                            ? f.color
                            : f.color + "5e",
                      }}
                    />
                  </SizeFace>,
                  ...dataSmile,
                ];
                break;
              case 1:
                dataSmile = [
                  <SizeFace key={idQuestion + "_" + index} color={f.color}>
                    <h3
                      style={
                        configuration.customStyle
                          ? configuration.answer
                          : answerConfiguration
                      }
                    >
                      {" "}
                      {f.lbtext}{" "}
                    </h3>
                    <SentimentVerySatisfiedTwoToneIcon
                      onClick={() =>
                        setQualificationSmile(
                          f.value,
                          f.lbtext,
                          idQuestion,
                          tpsurveyAnswerQuestionSurveys,
                          configuration.typeQuestion
                        )
                      }
                      style={{
                        fill:
                          actualQuestionSmile.length &&
                          actualQuestionSmile[0].answerClient === f.value
                            ? f.color
                            : f.color + "5e",
                      }}
                    />
                  </SizeFace>,
                  ...dataSmile,
                ];
                break;
              default:
                dataSmile = [...dataSmile];
                break;
            }
          });

        return (
          <SmileyFace backgroundColor={configuration?.background}>
            {dataSmile}
          </SmileyFace>
        );

      case "MultipleChoiceMultiSelect":
        return (
          <OptionsSection>
            {configuration && configuration.answerList.length > 0
              ? configuration.answerList
                  .filter((i) => i !== "Other")
                  .map((child) => {
                    return (
                      <OptionWrapper key={child} editable={true}>
                        <input
                          type="checkbox"
                          onClick={() =>
                            setQualificationMultipleChoice(
                              child,
                              idQuestion,
                              tpsurveyAnswerQuestionSurveys,
                              configuration.typeQuestion
                            )
                          }
                          defaultValue={child}
                        />{" "}
                        <label
                          style={
                            configuration.customStyle
                              ? configuration.answer
                              : answerConfiguration
                          }
                        >
                          {child}
                        </label>
                      </OptionWrapper>
                    );
                  })
              : null}
            {configuration && configuration.answerList.length > 0
              ? configuration.answerList
                  .filter((i) => i === "Other")
                  .map((child) => {
                    let position = QuestionsSave.findIndex(
                      (f) => f.idQuestion === idQuestion
                    );
                    let showText = QuestionsSave[
                      position
                    ]?.answerClient.includes("Other")
                      ? true
                      : false;
                    return (
                      <OptionWrapperOther key={child} editable={true}>
                        <input
                          type="checkbox"
                          defaultValue={child}
                          onClick={() =>
                            setQualificationMultipleChoice(
                              child,
                              idQuestion,
                              tpsurveyAnswerQuestionSurveys,
                              configuration.typeQuestion
                            )
                          }
                        />{" "}
                        <label
                          style={
                            configuration.customStyle
                              ? configuration.answer
                              : answerConfiguration
                          }
                        >
                          {child}
                        </label>
                        {showText && (
                          <input
                            type="text"
                            id={`MultipleChoiceMultiSelectOther-${child}`}
                            name={`MultipleChoiceMultiSelectOther-${idQuestion}`}
                            onBlur={(e) =>
                              setQualificationMultipleChoice(
                                child + ":" + e.target.value,
                                idQuestion,
                                tpsurveyAnswerQuestionSurveys,
                                configuration.typeQuestion
                              )
                            }
                          />
                        )}
                      </OptionWrapperOther>
                    );
                  })
              : null}
          </OptionsSection>
        );
      case "MultipleChoiceSingleSelect":
        return (
          <OptionsSection>
            {configuration && configuration.answerList.length > 0
              ? configuration.answerList
                  .filter((i) => i !== "Other")
                  .map((child) => {
                    return (
                      <OptionWrapper key={child} editable={true}>
                        <input
                          type="radio"
                          id={`MultipleChoiceSingleSelect-${child}`}
                          name={`MultipleChoiceSingleSelect-${idQuestion}`}
                          onClick={() =>
                            setQualificationMultipleChoiceSingle(
                              child,
                              idQuestion,
                              tpsurveyAnswerQuestionSurveys,
                              configuration.typeQuestion,
                              questionProps
                            )
                          }
                          defaultValue={child}
                        />{" "}
                        <label
                          style={
                            configuration.customStyle
                              ? configuration.answer
                              : answerConfiguration
                          }
                        >
                          {child}
                        </label>
                      </OptionWrapper>
                    );
                  })
              : null}
            {configuration && configuration.answerList.length > 0
              ? configuration.answerList
                  .filter((i) => i === "Other")
                  .map((child) => {
                    let position = QuestionsSave.findIndex(
                      (f) => f.idQuestion === idQuestion
                    );
                    let showText = QuestionsSave[
                      position
                    ]?.answerClient.includes("Other")
                      ? true
                      : false;
                    return (
                      <OptionWrapperOther key={child} editable={true}>
                        <input
                          type="radio"
                          id={`MultipleChoiceSingleSelect-${child}`}
                          name={`MultipleChoiceSingleSelect-${idQuestion}`}
                          defaultValue={child}
                          onClick={() =>
                            setQualificationMultipleChoiceSingle(
                              child,
                              idQuestion,
                              tpsurveyAnswerQuestionSurveys,
                              configuration.typeQuestion,
                              questionProps
                            )
                          }
                        />{" "}
                        <label
                          style={
                            configuration.customStyle
                              ? configuration.answer
                              : answerConfiguration
                          }
                        >
                          {child}
                        </label>
                        {showText && (
                          <input
                            type="text"
                            id={`MultipleChoiceSingleSelectOther-${child}`}
                            name={`MultipleChoiceSingleSelectOther-${idQuestion}`}
                            onBlur={(e) =>
                              setQualificationMultipleChoiceSingle(
                                child + ":" + e.target.value,
                                idQuestion,
                                tpsurveyAnswerQuestionSurveys,
                                configuration.typeQuestion,
                                questionProps
                              )
                            }
                          />
                        )}
                      </OptionWrapperOther>
                    );
                  })
              : null}
          </OptionsSection>
        );
      case "MultipleChoiceImageSingleSelect":
        return (
          <OptionsSection>
            {configuration && configuration.answerList.length > 0
              ? configuration.answerList.map((child, i) => {
                  return (
                    <div key={i}>
                      <OptionWrapper key={child.text} editable={true}>
                        <input
                          type="radio"
                          id={`MultipleChoiceImageSingleSelect-${child.text}`}
                          name={`MultipleChoiceImageSingleSelect-${idQuestion}`}
                          onClick={() =>
                            setQualificationMultipleChoiceSingle(
                              child.text + "|" + child.image,
                              idQuestion,
                              tpsurveyAnswerQuestionSurveys,
                              configuration.typeQuestion,
                              questionProps
                            )
                          }
                          defaultValue={child.text}
                        />{" "}
                        <label
                          style={
                            configuration.customStyle
                              ? configuration.answer
                              : answerConfiguration
                          }
                        >
                          {child.text}
                        </label>
                      </OptionWrapper>

                      <ShowImageContainer
                        src={
                          imagesChoice.filter(
                            (i) => i.nameImage === child.image
                          )[0]?.url
                        }
                      ></ShowImageContainer>
                    </div>
                  );
                })
              : null}
          </OptionsSection>
        );
      case "DropdownSingleSelect":
        return (
          <OptionsSection>
            <DropdownOptionWrapper
              key={`OptionWrapper-DropdownSingleSelect-${idQuestion}`}
              editable={true}
            >
              <select
                id={`DropdownSingleSelect-${idQuestion}`}
                onChange={(e) =>
                  setQualificationDropdownSingleSelect(
                    e,
                    idQuestion,
                    tpsurveyAnswerQuestionSurveys,
                    configuration.typeQuestion
                  )
                }
              >
                <option value="" disabled selected>
                  - Select an option -
                </option>
                {configuration && configuration.answerList.length > 0
                  ? configuration.answerList.map((child) => {
                      return (
                        <option key={child} value={child}>
                          {child}
                        </option>
                      );
                    })
                  : null}
              </select>
            </DropdownOptionWrapper>
          </OptionsSection>
        );
      case "File":
        return (
          <OptionsSection>
            <SelectsSection>
              <div>
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={(e) => {
                    setQualificationAttachFile(
                      e,
                      idQuestion,
                      tpsurveyAnswerQuestionSurveys,
                      questionProps.questionType
                    );
                  }}
                />
              </div>
            </SelectsSection>
          </OptionsSection>
        );
      default:
        return null;
    }
  };

  const fnShowQuestion = (q) => {
    return (
      !q.isDependent ||
      (q.isDependent &&
        answersDependent.findIndex(
          (f) =>
            f.idQuestionSurvey === q.idParentQuestion &&
            f.answer === q.dependentAnswer
        ) > -1)
    );
  };

  let saveFormFilling = () => {
    if (buttonSaveConfigurationPreview) {
      saveForm(formData);
    } else {
      return null;
    }
  };

  return (
    <GeneralFillOutSurvey>
      <Background
        backgroundColor={
          backgroundConfiguration && backgroundConfiguration.color
        }
        image={imgBackground}
      >
        <ContentQuestions>
          <ContentInternal>
            {title && (
              <div
                dangerouslySetInnerHTML={{
                  __html: title,
                }}
              ></div>
            )}

            {questiondata &&
              questiondata
                .slice()
                .sort((s, n) => {
                  return parseInt(s.questionOrder) - parseInt(n.questionOrder);
                })
                .map((q, index) => {
                  let question = "";
                  if (q.jsonConfiguration) {
                    question = JSON.parse(q.jsonConfiguration);
                  }
                  return (
                    <SlideDown key={index} className={"my-dropdown-slidedown"}>
                      {fnShowQuestion(q) && (
                        <GeneralStyle
                          color={
                            question.customStyle ? question.background : null
                          }
                          key={q.idQuestionForm}
                        >
                          <LowerWrapper>
                            <ContentMandatory>
                              {q.isMandatory && <Ismandatory>*</Ismandatory>}
                              {q.questionType !== "File" && (
                                <h2
                                  style={
                                    question.customStyle
                                      ? question.question
                                      : questionsConfiguration
                                  }
                                >
                                  {q.questionTitle}
                                </h2>
                              )}
                            </ContentMandatory>

                            {answersType(
                              q.jsonConfiguration,
                              q.idQuestionForm,
                              q.tpsurveyAnswerQuestionSurveys,
                              q
                            )}
                            {showMandatory(q, question)}
                          </LowerWrapper>
                        </GeneralStyle>
                      )}
                    </SlideDown>
                  );
                })}
            <LowerWrapper>
              <HighAlertQuestionBlock
                preview={!buttonSaveConfigurationPreview}
                setHighPriority={setHighPriority}
                setHighPriorityReason={setHighPriorityReason}
                showError={showError}
              />
            </LowerWrapper>
            <div style={{ textAlign: "center", marginBottom: "1em" }}>
              {
                <StyledButton
                  onClick={saveFormFilling}
                  color={
                    buttonSaveConfiguration?.color
                      ? buttonSaveConfiguration?.color
                      : "#ffffff"
                  }
                  textDecoration={buttonSaveConfiguration?.textDecoration}
                  fontStyle={buttonSaveConfiguration?.fontStyle}
                  fontWeight={buttonSaveConfiguration?.fontWeight}
                  fontFamily={buttonSaveConfiguration?.fontFamily}
                  fontSize={buttonSaveConfiguration?.fontSize}
                  align={buttonSaveConfiguration?.align}
                  backgraundColor={buttonSaveConfiguration?.backgroundColor}
                  image={buttonSaveConfiguration?.image}
                  visibility={buttonSaveConfiguration?.visibility}
                >
                  Send
                </StyledButton>
              }
            </div>
          </ContentInternal>
        </ContentQuestions>
      </Background>
    </GeneralFillOutSurvey>
  );
};

export default FormFilling;
